// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"24":"userProfile-personalInformation","238":"userProfile-sampleRequests","518":"userProfile-notifications","642":"userProfile-privacy","751":"userProfile-productComparisons","784":"userProfile-status"}[chunkId] + ".3.7.0.js";
};